module.exports = "/_next/static/images/f1f9fcaab4b91614d30fbd8dc66e9033-dress-code-4.png";